import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Button,
  Select
} from '@chakra-ui/react';
import { CreatePhrasesApi } from '../../../../apis/CreateMaintenance.api';
import { CategroyNameType } from '../../../../apis/ApiClient';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';
import { PhrasesType } from '../Table/MaintenancePhrasesTable';

interface props {
  isOpen: boolean;
  onClose: () => void;
  CategoryDatas: CategroyNameType[] | undefined;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<PhrasesType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const GetPhrasesInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 300, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 300, BanInputType: BanInputType.None, Value: addData };
};

const PhrasesCreateWindow: React.FC<props> = (props) => {
  const {
    isOpen,
    onClose,
    CategoryDatas,
    setMaintenanceDatas,
    CreateOrUpdateStateSwitch
  } = props;
  const [categoryId, setCategoryId] = useState(
    CategoryDatas !== undefined ? CategoryDatas[0].id : 1
  );
  const [phrases, setPhrases] = useState<string | undefined>('');
  const CreateApi = async () => {
    const response = await CreatePhrasesApi({
      category_id: categoryId,
      body: phrases
    });
    if (response.success === false) {
      alert('登録に失敗しました。');
      return;
    }
    setMaintenanceDatas(response.data as PhrasesType[]);
    CreateOrUpdateStateSwitch();
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='320px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            定型文作成
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>カテゴリ名</Text>
              <Select
                mt={2}
                w='100%'
                value={categoryId}
                onChange={(e) => {
                  setCategoryId(Number(e.target.value));
                }}
              >
                {CategoryDatas?.map((data, i) => {
                  return (
                    <option key={'category' + i} value={data.id}>
                      {data.category}
                    </option>
                  );
                })}
              </Select>

              <Text mt={4}>定型文</Text>
              <CustomStringInput
                CheckInfo={GetPhrasesInputCheckData('')}
                inputValue={phrases}
                setValue={setPhrases}
                PhohibitionCharaCheck={false}
              />
            </Box>
            <Button mt={10} onClick={() => CreateApi()}>
              作成
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(PhrasesCreateWindow);
